const LabelHelper = {
	expenseChannel(channel) {
		switch (channel) {
			case 'email':
				return 'Email';
			case 'whatsapp':
				return 'WhatsApp';
			case 'web_upload':
				return 'Web Upload';
			case 'mobile':
				return 'Mobile';
			default:
				return '';
		}
	},
	expenseCurrency(currency) {
		switch (currency) {
			case 'aud':
				return 'AUD $';
			case 'cad':
				return 'CAD $';
			case 'chf':
				return 'CHF Fr.';
			case 'cny':
				return 'CNY ¥';
			case 'eur':
				return 'EUR €';
			case 'gbp':
				return 'GBP £';
			case 'hkd':
				return 'HKD $';
			case 'inr':
				return 'INR ₹';
			case 'jpy':
				return 'JPY ¥';
			case 'krw':
				return 'KRW ₩';
			case 'myr':
				return 'MYR RM';
			case 'nzd':
				return 'NZD $';
			case 'php':
				return 'PHP ₱';
			case 'sgd':
				return 'SGD $';
			case 'thb':
				return 'THB ฿';
			case 'twd':
				return 'TWD NT$';
			case 'usd':
				return 'USD $';
			default:
				return '';
		}
	},
	expenseCategory(category_selection) {
		switch (category_selection) {
			case 'advertising_and_marketing':
				return 'Advertising and Marketing';
			case 'bank_and_finance_charges':
				return 'Bank and Finance Charges';
			case 'benefits':
				return 'Benefits';
			case 'car':
				return 'Car';
			case 'communication':
				return 'Communication';
			case 'depreciation':
				return 'Depreciation';
			case 'donations_and_charity':
				return 'Donations and Charity';
			case 'education_and_training':
				return 'Education and Training';
			case 'equipment':
				return 'Equipment';
			case 'fees':
				return 'Fees';
			case 'home_office':
				return 'Home Office';
			case 'insurance':
				return 'Insurance';
			case 'interest':
				return 'Interest';
			case 'labor':
				return 'Labor';
			case 'maintenance':
				return 'Maintenance';
			case 'materials':
				return 'Materials';
			case 'meals_and_entertainment':
				return 'Meals and Entertainment';
			case 'medical':
				return 'Medical';
			case 'office_supplies':
				return 'Office Supplies';
			case 'parking_and_tolls':
				return 'Parking and Tolls';
			case 'professional_services':
				return 'Professional Services';
			case 'rent':
				return 'Rent';
			case 'shipping_and_delivery':
				return 'Shipping and Delivery';
			case 'software_and_subscriptions':
				return 'Software and Subscriptions';
			case 'taxes':
				return 'Taxes';
			case 'travel':
				return 'Travel';
			case 'utilities':
				return 'Utilities';
			case 'other':
				return 'Other';
			default:
				return '';
		}
	},
	paymentMethod(payment) {
		switch (payment) {
			case 'alipay':
				return 'Alipay';
			case 'apple_pay':
				return 'Apple Pay';
			case 'bank_transfer':
				return 'Bank Transfer';
			case 'cash':
				return 'Cash';
			case 'cheque':
				return 'Cheque';
			case 'credit_debit_card':
				return 'Credit/Debit Card';
			case 'google_pay':
				return 'Google Pay';
			case 'octopus':
				return 'Octopus';
			case 'other':
				return 'Other';
			case 'paypal':
				return 'PayPal';
			case 'wechat_pay':
				return 'Wechat Pay';
			default:
				return '';
		}
	},
	accountChannel(channel) {
		switch (channel) {
			case 'email':
				return 'Email';
			case 'whatsapp':
				return 'WhatsApp';
			default:
				return '';
		}
	},
	accountStatus(status) {
		switch (status) {
			case 'verified':
				return 'Verified';
			case 'unverified':
				return 'Pending Verification';
			default:
				return '';
		}
	},
	subscriptionPlan(plan) {
		switch (plan) {
			case 'monthly':
				return 'Monthly';
			default:
				return '';
		}
	},
	subscriptionStatus(status) {
		switch (status) {
			case 'trialing':
				return 'Free Trial';
			case 'active':
				return 'Active';
			case 'canceled':
				return 'Canceled';
			case 'paid':
				return 'Paid';
			default:
				return '';
		}
	},
	invoiceStatus(status) {
		switch (status) {
			case 'draft':
				return 'Draft';
			case 'open':
				return 'Open';
			case 'paid':
				return 'Paid';
			case 'void':
				return 'Void';
			case 'uncollectible':
				return 'Uncollectible';
			default:
				return '';
		}
	}
};

export default LabelHelper;
